import React, { useState, useContext } from "react";
import { Formik, Form, Field } from "formik";
import { Col, FormGroup, FormControl } from "react-bootstrap";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { BsFillCalendarEventFill, BsCalendarCheck, BsCalendarX } from "react-icons/bs";
import { MdOutlineModeEditOutline } from "react-icons/md";
import * as Yup from "yup";
import Select from "../../../shared/Select";
import Lead from "../../../shared/Lead";
import SelectPcp from "../../forms/SelectPcp";
import SelectVisitType from "../../forms/SelectVisitType";
import FieldError from "../../../shared/FieldError";
import ViewDocument from "../../../shared/ViewDocument";
import { Task, Settings } from "../../../helpers/Contexts";
import * as CONST from "../../../helpers/Constants";
import Rescheduled from "./Rescheduled";
import CprData from "../cpr/CprData";

const CompletedAppointmentSchema = Yup.object().shape({
  document: Yup.mixed(),
  date: Yup.date().required("Completed on date is required."),
  completed_on_date: Yup.date(),
  procedure_type: Yup.string().required("Visit type is required"),
  pcp: Yup.string(),
});

const Complete = ({ appointment, formHandler }) => {
  const settings = useContext(Settings);
  const { taskValues, setTaskValues } = useContext(Task);
  const [showDateSelector, setShowDateSelector] = useState(false);
  const [appointmentRescheduled, setAppointmentRescheduled] = useState(false);
  const [selectCompleted, setSelectCompleted] = useState("");

  function renderRescheduled(val) {
    return (
      <>
        <Rescheduled
          data={{
            id: appointment.id,
            sub_status_list_id: val,
            appointment_date: appointment.cpr.appointment_date,
            appointment_time: appointment.cpr.appointment_time,
            formHandler: formHandler,
          }}
        />{" "}
      </>
    );
  }

  return (
    <>
      <Formik
        validationSchema={selectCompleted !== "completed" ? null : CompletedAppointmentSchema}
        validateOnChange={selectCompleted !== "completed" ? false : true}
        initialValues={
          appointment.cpr.completed_on_date
            ? {
                completed_on_date: appointment.cpr.completed_on_date,
                date: appointment.cpr.completed_on_date,
                pcp: appointment.cpr.attending_provider,
                pcp_id: appointment.cpr.attending_provider_id,
                procedure_type: appointment.cpr.procedure_type,
                procedure_type_id: appointment.cpr.procedure_type_id,
                document: appointment.cpr.document.url,
              }
            : {
                completed_on_date: "",
                document: "",
                date: "",
                pcp: "",
                pcp_id: "",
                due_date: "",
                procedure_type:
                  appointment.visitType == "Annual Wellness Visit" ||
                  appointment.visitType == "Telehealth Visit - Annual Wellness Visit (AWV)"
                    ? ""
                    : appointment.visitType,
                procedure_type_id:
                  appointment.visitType == "Annual Wellness Visit" ||
                  appointment.visitType == "Telehealth Visit - Annual Wellness Visit (AWV)"
                    ? ""
                    : appointment.cpr.procedure_type_id,
              }
        }
        onSubmit={(values) => {
          if (selectCompleted == "notCompleted") {
            return formHandler({
              task: {
                id: appointment.id,
                sub_status_list_id: values.sub_status_list_id,
                appointment_request_status: "appointment_not_completed",
                priority: null,
                due_date: values.due_date,
                status: "closed",
              },
            });
          } else {
            const formData = new FormData();
            formData.append("task[id]", appointment.id);
            formData.append("task[completed_on_date]", values.completed_on_date);
            formData.append("task[procedure_type_id]", values.procedure_type_id);

            !appointment.cpr.document.url && formData.append("task[document]", values.document);
            formData.append("task[status]", "open");
            formData.append(
              "task[appointment_request_status]",
              values.document ? "appointment_completed" : "visit_status_check"
            );
            values.procedure_type !== "Lab/Diagnostic Only" &&
              formData.append("task[attending_provider]", values.pcp);

            formData.append("task[event]", 'cpr_completed');
            return appointment.formHandler(formData);
          }
        }}
      >
        {({ values, setFieldValue, errors }) => {
          function renderCompletedForm() {
            let disableSubmit = [null, ""].includes(values.pcp) == true && appointment.attending_provider_required == true;

            return (
              <Form>
                <MdOutlineModeEditOutline id="pencil-icon" />{" "}
                <Lead message={"Editing Appointment Completed "} />
                <br />
                <BsCalendarCheck id="appointment-big-icon" />
                <br />
                <SelectVisitType
                  name="procedure_type"
                  setFieldValue={setFieldValue}
                  showPopup={true}
                  value={values.procedure_type_id}
                />
                <label>{"Attending Provider"}</label>
                {values.procedure_type == "Lab/Diagnostic Only" ? (
                  <select disabled className="dropdown-select">
                    <option value={""}>{"N/A for Lab/Diagnostic Only"}</option>
                  </select>
                ) : (
                  <SelectPcp name="pcp" pcpRequired={true} active={false} required={true} setFieldValue={setFieldValue} />
                )}
                {disableSubmit && (<>
                  <br />
                  <i>* Attending Provider is required</i>
                </>)}
                <label>Completed On Date</label>
                <div className={"flex datefield-wrapper full-width"}>
                  <Field name="date">
                    {({ field, meta }) => {
                      return (
                        <>
                          <BsFillCalendarEventFill className="calendar-icon" />
                          <ReactDatePicker
                            autoComplete="off"
                            className="datepicker"
                            maxDate={settings.me.environment == "production" ? new Date() : null}
                            {...field}
                            dateFromat={"YYYY-MM-dd"}
                            onChange={(date) => {
                              setFieldValue("completed_on_date", date);
                              setFieldValue("date", date.toISOString().slice(0, 10));
                            }}
                          />
                        </>
                      );
                    }}
                  </Field>
                </div>
                {errors.date ? <FieldError error={errors.date} /> : null}
                {appointment.cpr.document && appointment.cpr.document.url && (
                  <ViewDocument url={appointment.cpr.document.url} />
                )}{" "}
                {!appointment.cpr.document.url && (
                  <>
                    <label>Attach Visit Summary (If Available)</label>
                    <FormGroup controlId="formFile" className="mb-3">
                      <FormControl
                        type="file"
                        onChange={(e) => setFieldValue("document", e.target.files[0])}
                      />
                    </FormGroup>
                  </>
                )}
                <button className="check" type="submit" disabled={disableSubmit}>
                  Submit Appointment Completed
                </button>
              </Form>
            );
          }

          function renderNotCompletedForm() {
            return (
              <>
                <Lead message={"Appointment Status Check"} />
                <br />
                <br />

                <b>Did the patient complete this appointment ?</b>
                <select
                  className="cpr-form"
                  onChange={(e) => {
                    e.target.value == "completed"
                      ? setSelectCompleted("completed") && toggleSubStatus(true)
                      : setSelectCompleted("notCompleted") && toggleSubStatus(false);
                    if (values.sub_status_list_id) {
                      setFieldValue("sub_status_list_id", "");
                    }
                  }}
                >
                  <option value={""}>{"Select an option"}</option>
                  <option value={"completed"}>{"Yes, patient completed appointment."}</option>
                  <option value={"notCompleted"}>
                    {"No, patient did not complete appointment."}
                  </option>
                </select>
                {selectCompleted == "notCompleted" && (
                  <>
                    <br />
                    <br />
                    <b>Tell Us Why</b>
                    <Form>
                      <Select
                        className="cpr-form"
                        value={values.sub_status_list_id || ""}
                        required={true}
                        name="sub_status_list_id"
                        onChange={(e) => {
                          setFieldValue("date", values.date);
                          setFieldValue("pcp", values.pcp);
                          setFieldValue("procedure_type", values.procedure_type);
                          setFieldValue("sub_status_list_id", e.target.value);
                          let label = settings.appointment_status_options.find((el) => el.id == e.target.value).label;
                          if (CONST.SUB_STATUSES_SHOW_DUE_DATE_SELECTOR.includes(label)) {
                            setShowDateSelector(true);
                          }

                          settings.appointment_status_options.filter(
                            (i) => i.id == e.target.value
                          )[0].value == CONST.CPR.RESCHEDULED
                            ? setAppointmentRescheduled(true)
                            : setAppointmentRescheduled(false);
                        }}
                      >
                        <option value="">{"Select an option"}</option>
                        {settings.appointment_status_options.map((i) => (
                          <option key={i.value} value={i.id}>
                            {i.label}
                          </option>
                        ))}
                      </Select>

                      { showDateSelector && (<>
                        <Field name="appointment_initiated_date">
                          {
                            ({ field, meta }) => {
                              return(
                                <>
                                  <label>Select a due date</label>
                                  <ReactDatePicker
                                    className="date-picker-selector"
                                    autoComplete="off"
                                    minDate={new Date()}
                                    selected={values.due_date}
                                    placeholder="Select a Date"
                                    {...field}
                                    dateFromat={"YYYY-MM-dd"}
                                    onChange={(date) => {
                                      setFieldValue("due_date", date);
                                    }}
                                  />
                                </>
                              );
                            }
                          }
                        </Field>
                      </>)}

                      {!appointmentRescheduled && (
                        <button className="check" type="submit">
                          Submit Appointment Status Check
                        </button>
                      )}
                    </Form>{" "}
                    {appointmentRescheduled && renderRescheduled(values.sub_status_list_id)}
                  </>
                )}
              </>
            );
          }

          const ViewCompleted = () => {
            return (
              <>
                {!taskValues.editing.completed && (
                  <>
                    <Lead message={"Appointment Completed"} />
                    <br />
                    <BsCalendarCheck id="appointment-big-icon" />
                    <br />
                    <label>Visit Type</label>
                    {appointment.cpr.procedure_type}
                    <label>{"Attending Provider"}</label>
                    {appointment.cpr.procedure_type == "Lab/Diagnostic Only"
                      ? "N/A for Lab/Diagnostic Only"
                      : appointment.cpr.attending_provider && appointment.cpr.attending_provider}
                    <label>{"Completed on Date"}</label>
                    {appointment.cpr.completed_on_date}
                    <label>{"Verified by Claims:"}</label>
                    {appointment.cpr.verified_in_claims == true ? "Yes" : "No"}
                    <br />
                    {appointment.cpr.document.url && (
                      <ViewDocument url={appointment.cpr.document.url} />
                    )}
                  </>
                )}{" "}
                {taskValues.editing.completed && renderCompletedForm()}
              </>
            );
          };

          return (
            <Col className="appointment br " md={12} lg={4} sm={12}>
              {appointment.cpr.completed_on_date && <ViewCompleted />}
              {appointment.cpr.completed_on_date &&
                !appointment.cpr.document.url &&
                !taskValues.editing.completed && (
                  <>
                    <label>Attach Visit Summary (If available)</label>
                    <Form>
                      <FormGroup controlId="formFile" className="mb-3">
                        <FormControl
                          type="file"
                          onChange={(e) => setFieldValue("document", e.target.files[0])}
                        />
                      </FormGroup>
                      <button className="check" type="submit">
                        Submit Appointment Completed
                      </button>
                    </Form>
                  </>
                )}

              {!appointment.cpr.completed_on_date &&
                appointment.appointment_request_status !== "appointment_not_completed" &&
                selectCompleted !== "completed" &&
                renderNotCompletedForm()}
              {selectCompleted == "completed" && renderCompletedForm()}
              {appointment.appointment_request_status == "appointment_not_completed" && (
                <>
                  <Lead message={"Appointment Not Completed"} />
                  <br />
                  <BsCalendarX id="appointment-big-icon" />
                  <br />
                  <CprData
                    data={{
                      ...appointment.cpr,
                      task: appointment,
                      taskId: appointment.id,
                      formHandler: formHandler,
                    }}
                  />
                </>
              )}
            </Col>
          );
        }}
      </Formik>
    </>
  );
};

export default Complete;
